<fs-map
  *ngIf="lprCamera.latitude && lprCamera.longitude"
  zoom="19"
  [center]="[lprCamera.longitude, lprCamera.latitude]"
  (mapInit)="onMapInit($event)"
></fs-map>
